import actionCreatorFactory from "typescript-fsa";
import { AccountDetailRequestBody, AccountDetailResponse } from "../../core/api/requests/account/detail/types";
import { AccountEditRequestBody, AccountEditResponse } from "../../core/api/requests/account/edit/types";
import { AccountListRequestBody, AccountListResponse } from "../../core/api/requests/account/list/types";
import { AccountRegisterRequestBody, AccountRegisterResponse } from "../../core/api/requests/account/register/types";
import { CommonAsyncType } from "../../core/types";

const actionCreator = actionCreatorFactory("@@User");

export const userActions = {
  fetchUsers: actionCreator.async<CommonAsyncType<AccountListResponse> & AccountListRequestBody, AccountListResponse>("FETCH_USERS"),
  getUserDetails: actionCreator.async<CommonAsyncType<AccountDetailResponse> & AccountDetailRequestBody, AccountDetailResponse>("GET_USER_DETAILS"),
  registerNewUser: actionCreator.async<CommonAsyncType<AccountRegisterResponse> & AccountRegisterRequestBody, AccountRegisterResponse>("REGISTER_NEW_USER"),
  updateUser: actionCreator.async<CommonAsyncType<AccountEditResponse> & AccountEditRequestBody, AccountEditResponse>("UPDATE_USER"),
  resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
};
